'use client'

import shillIcon from "../../public/shill.png";
import starIcon from "../../public/star.png";
import venIcon from "../../public/ven.png";
import packageIcon from "../../public/package.png";
import Image from "next/image";

export default function Facility(){
     const trusted = [
        { img: shillIcon, title: "100% Original" },
        { img: starIcon, title: "Certified by Brands" },
        { img: venIcon, title: "Direct Sourcing" },
        { img: packageIcon, title: "Secure Packaging" },
      ];
    return(
       <div className="w-full min-h-[132px]  flex  overflow-hidden xl:px-8 2xl:px-14 md:px-5 px-3 xl:py-4 2xl:py-4 md:py-4 py-10 ">
  <div className="w-full flex flex-wrap justify-between 2xl:gap-8 xl:gap-16 gap-8">
    {trusted.map((item, idx) => (
      <div
        key={idx}
        className="flex items-center gap-4 "
      >
        {/* Icon Container */}
        <div className="relative bg-[#d7d4d4] rounded-full w-14 h-14 flex items-center justify-center">
          <Image
            src={item.img}
            alt={item.title}
            width={28}
            height={28}
            className="object-contain"
          />
        </div>

        {/* Title */}
        <span className="text-gray-800 text-lg font-medium">
          {item.title}
        </span>
      </div>
    ))}
  </div>
</div>

        
    )
}